import axios from "axios";

const main = async (token, setPosts, setLoading) => {
  const URL = "https://eastern-surface-293816.el.r.appspot.com/api/posts/hot";
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const { data, status } = await axios.get(URL, { headers });

  if (status === 200) {
    setPosts((prevPosts) => [...prevPosts, ...data]);
    setLoading(false);
  }
};

export default main;
